import { render } from "./MainLinks.vue?vue&type=template&id=67d1855f&scoped=true&ts=true"
import script from "./MainLinks.vue?vue&type=script&lang=ts"
export * from "./MainLinks.vue?vue&type=script&lang=ts"

import "./MainLinks.vue?vue&type=style&index=0&id=67d1855f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d1855f"]])

export default __exports__